<template>
  <div id="app">
    <customer v-if="address_id && allProducts.length" :address_id="address_id" :all-products="allProducts"></customer>
    <admin v-if="!address_id && allProducts.length" :all-products="allProducts"/>
  </div>
</template>

<script>
import axios from 'axios';
axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  ? 'https://westward-whiskey-api.herokuapp.com'
  : 'http://localhost:9696';
// axios.defaults.baseURL = 'https://westward-whiskey-api.herokuapp.com'


import ShopifyRepository from './shopify/shopifyRepository';
import { COLLECTION } from './shopify/products.graphql.js';


import admin from './components/admin/Admin.vue'
import customer from './components/Customer.vue'
import _get from 'lodash/get'


const frontClient = new ShopifyRepository();

export default {
  name: 'App',
  components: {
    admin,
    customer
  },
  data: () => ({
    allProducts: []
  }),
  props: ["address_id", "collection-handle"],
  async created() {
    this.allProducts = await this.fetchAllProductsByCollection();

    // Insert some id value or null to controll which panel will apear, customer or admin
    if (process.env.NODE_ENV === 'development') {
      this.address_id = 74009161; // VPV Test Account
      // this.address_id = null; // Admin Access 
    }
  },
  methods: {
    async fetchAllProductsByCollection() {
      const coll = await frontClient.loadQuery(COLLECTION, { handle: this.collectionHandle || 'whiskey-recharge-app-collection' });
      return _get(coll, 'data.collectionByHandle.products.edges');
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin: 3rem 0 0 1rem;
  padding: 3rem; */
  background: #f8f7f1;
}


@media only screen and (min-width: 767px) {
  #app {
    padding: 3rem;
  }
}


</style>
